import { Card } from '@/components/UI';
import type { TradeLogicCapabilityErrorDetails } from '@/api/getTradeLogicCapabilityError.ts';

type TradeLogicCapabilityIssue = TradeLogicCapabilityErrorDetails['issues'][number];

interface TradeLogicCapabilityErrorCardProps {
    capabilityError: TradeLogicCapabilityErrorDetails;
    title: string;
}

const TradeLogicCapabilityErrorCard = ({ capabilityError, title }: TradeLogicCapabilityErrorCardProps) => (
    <Card className="mb-4 border-red-900/70 bg-red-950/40">
        <div className="text-sm text-red-100">
            <div className="font-medium text-red-50">{title}</div>
            <div className="mt-1 text-xs text-red-200/80">
                Definition: {capabilityError.definitionName} · Modes: {capabilityError.evaluationModes.join(', ')}
            </div>
            {capabilityError.issues.length > 0 && (
                <ul className="mt-2 space-y-1 text-xs text-red-100/90">
                    {capabilityError.issues.map((issue: TradeLogicCapabilityIssue) => (
                        <li key={`${issue.mode}-${issue.key}-${issue.reason}`}>{issue.reason}</li>
                    ))}
                </ul>
            )}
        </div>
    </Card>
);

export default TradeLogicCapabilityErrorCard;
